var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.421 1.58334C14.7934 1.58334 18.3377 5.12764 18.3377 9.50001C18.3377 13.8724 14.7934 17.4167 10.421 17.4167C6.04865 17.4167 2.50436 13.8724 2.50436 9.50001C2.50436 5.12764 6.04865 1.58334 10.421 1.58334ZM10.421 4.75001C10.2111 4.75001 10.0097 4.83342 9.86123 4.98188C9.71276 5.13035 9.62936 5.33171 9.62936 5.54168V9.50001C9.6294 9.70996 9.71284 9.91129 9.86131 10.0597L12.2363 12.4347C12.3856 12.5789 12.5856 12.6587 12.7932 12.6569C13.0007 12.6551 13.1993 12.5719 13.3461 12.4251C13.4929 12.2783 13.5761 12.0797 13.5779 11.8722C13.5797 11.6646 13.4999 11.4646 13.3557 11.3153L11.2127 9.17226V5.54168C11.2127 5.33171 11.1293 5.13035 10.9808 4.98188C10.8323 4.83342 10.631 4.75001 10.421 4.75001Z",
    fill: "#9A999D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(0.921021)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time_icon.c8fb6218b1ddf96e74e2c0005132585d.svg";
export { ForwardRef as ReactComponent };